<template>
  <v-slide-y-transition mode="out-in">
    <v-container>
      <div class="training-banner">
        <h2>Does your team need training?</h2>
        <router-link tag="button" class="v-btn v-btn-flat" to="/evaluation">Find out now</router-link>
      </div>
      <router-view></router-view>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
export default {
  name: 'services'
}
</script>

<style>
.card-title {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: rgba(255,255,255,0.6);
  text-shadow: 2px 2px 4px #000;
}
.card-title span {
  font-size: 1.5em;
  font-weight: bold;
}
.v-parallax__content h2 {
  background: rgba(255,255,255,0.6);
  bottom: 0;
  position: absolute;
  width: 100%;
  margin: 0;
  margin-left: -14px;
  padding: 5px 20px;
  text-shadow: 2px 2px 4px #000;
}
.cta-block {
  border: 1px #999999 solid;
  background: #EFEFEF;
  box-shadow: 0px 2px 2px #999999;
  font-size: 1.25em;
  text-align: center;
  padding: 20px;
  margin: 20px 0;
  font-weight: 500;
  letter-spacing: .125em;
}
</style>




// WEBPACK FOOTER //
// src/components/Topics.vue